var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMostReposted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.464,
    cy: 49.464,
    r: 49.464,
    fill: "#01A0C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2689 65.6413C33.9928 65.6433 33.7673 65.4211 33.7653 65.145L33.5348 33.8979C33.5327 33.6217 33.7549 33.3962 34.0311 33.3942L41.9981 33.3354C42.4436 33.3321 42.6627 32.7919 42.3454 32.4793L30.5674 20.8738C30.3707 20.68 30.0541 20.6823 29.8603 20.879L18.2548 32.657C17.9421 32.9743 18.1692 33.5112 18.6146 33.5079L26.5817 33.4492C26.8578 33.4471 27.0833 33.6693 27.0853 33.9455L27.3634 71.642C27.3655 71.9181 27.591 72.1403 27.8671 72.1383L46.2154 72.0029C46.4915 72.0009 46.7137 71.7754 46.7117 71.4993L46.6715 66.0498C46.6695 65.7737 46.444 65.5515 46.1678 65.5535L34.2689 65.6413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2774 33.1642C65.5535 33.1621 65.779 33.3843 65.781 33.6605L66.0115 64.9076C66.0136 65.1837 65.7914 65.4092 65.5152 65.4113L57.5482 65.47C57.1027 65.4733 56.8836 66.0135 57.2009 66.3262L68.9789 77.9317C69.1756 78.1255 69.4922 78.1232 69.686 77.9265L81.2915 66.1485C81.6042 65.8312 81.3771 65.2942 80.9317 65.2975L72.9646 65.3563C72.6885 65.3583 72.463 65.1361 72.461 64.86L72.1829 27.1635C72.1808 26.8873 71.9553 26.6651 71.6792 26.6672L53.3309 26.8025C53.0548 26.8046 52.8326 27.0301 52.8346 27.3062L52.8748 32.7556C52.8768 33.0318 53.1024 33.254 53.3785 33.2519L65.2774 33.1642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostReposted);
export default __webpack_public_path__ + "static/media/most-reposted.1f75314a.svg";
export { ForwardRef as ReactComponent };